import type { ShoppingDistrictSpec } from "./shoppingDistrict";

/**
 * Riverside (world v5, ADR-0041 decision 3): east of Central (x 312..632). World v6 (ADR-0042): Market Street runs on
 * east into River Street at the old wall line (x = 312), so Riverside is reached on foot or by car along the road. River
 * Street with shops c-64..c-83 (north row west to east, then the south row), Alder Lane (nearer Central, r-41..r-50) and
 * Hazel Lane (r-51..r-60), Mill Road behind them; billboards bb-5 (the square) and bb-6 (the far end of River Street).
 */
export const RIVERSIDE: ShoppingDistrictSpec = {
  id: "riverside",
  name: "Riverside",
  side: 1,
  streetName: "River Street",
  laneNames: ["Alder Lane", "Hazel Lane"],
  backRoadName: "Mill Road",
  firstShop: 64,
  firstPlot: 41,
  billboardIds: ["bb-5", "bb-6"],
  northStyles: ["office_block", "small_shop", "colorful_tower", "corner_shop", "modern_midrise", "landmark_tower", "small_shop", "office_block", "modern_midrise", "corner_shop"],
  southStyles: ["corner_shop", "modern_midrise", "landmark_tower", "small_shop", "office_block", "colorful_tower", "small_shop", "corner_shop", "landmark_tower", "modern_midrise"],
};
